import script from "./footer-business-info.vue?vue&type=script&setup=true&lang=ts"
export * from "./footer-business-info.vue?vue&type=script&setup=true&lang=ts"

import "./footer-business-info.vue?vue&type=style&index=0&id=3626ddab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3626ddab"]])

export default __exports__